/* eslint-disable import/newline-after-import */
/* eslint-disable object-curly-newline */
/* eslint-disable no-plusplus */
import React, {
  useMemo, useState, forwardRef, useEffect, useContext
} from 'react';
import { Form, Title, Button, Text, Spacer } from 'components/atoms';
import { Formik, Field } from 'formik';
import {
  FieldArrayDndFormik, FieldCustom, FieldToggle, FieldSelect
} from 'components/molecules';
import PropTypes from 'prop-types';
import { useFormikForwardRef } from 'hooks'
import { useDebounce } from 'react-use'
import { generateKey } from 'services/generators'
import { PeopleList } from 'containers';
import { useParams } from 'react-router-dom';
import { useEditorContext, actions } from 'context/EditorContext';
import { ThemeContext } from 'styled-components';
import { useUserContext } from 'context/UserContext';
import {
  getDepartmentPeople, getPeopleTabs
} from '../../services/requests';
import { ItemSchema } from './utils';

const computeDropTabs = (opts, valueKey = 'value', labelKey = 'label') => opts.map((option) => ({
  value: option[valueKey],
  label: option[labelKey],
  original: option
}))

// eslint-disable-next-line react/prop-types
const ItemFormItem = forwardRef(({ initialValues, onSubmit }, ref) => {
  // this is necessary for all FieldArrayDnd forms
  // in order to control the submitForm from parent
  const formRef = useFormikForwardRef(ref);
  const [peopleArray, setPeopleArray] = useState([])
  const initialValuesComputed = useMemo(() => initialValues, [initialValues])
  const formToModuleSchema = (values) => values
  const { subweb, lang } = useParams();
  
  const handleClickAdd = (rec) => {
    let aux = null;
    const newArray = [...peopleArray]

    if (peopleArray.length > 0) {
      if (rec.check) {
        for (let i = 0; i < peopleArray.length; i++) {
          if (rec.photoId === peopleArray[i].photoId) {
            aux = i
          }
        }
        if (aux !== null) {
          newArray.splice(aux, 1)
          setPeopleArray(newArray)
        } else {
          newArray.push(rec)
          setPeopleArray(newArray)
        }
      } else {
        for (let i = 0; i < peopleArray.length; i++) {
          if (rec.photoId === peopleArray[i].photoId) {
            aux = i
          }
        }
        newArray.splice(aux, 1)
        setPeopleArray(newArray)
      }
    } else if (rec.check) {
      newArray.push(rec)
      setPeopleArray(newArray)
    }
  }

  return (
    <Formik
      ref={formRef}
      initialValues={initialValuesComputed}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(formToModuleSchema(peopleArray));
        setSubmitting(false);
        setPeopleArray([])
      }}
      validateOnMount
      enableReinitialize
    >
      <>
        <Form>
          <PeopleList
            lang={lang}
            subweb={subweb}
            isPeopleModule
            onClickAdd={(rec) => handleClickAdd(rec)}
            value="true"
          />
        </Form>
      </>
    </Formik>
  )
})

// eslint-disable-next-line react/prop-types
const ItemForm = forwardRef(({ initialValues, onSubmit }, ref) => {

  // this is necessary for all FieldArrayDnd forms
  // in order to control the submitForm from parent
  const [context, dispatch] = useEditorContext();
  const formRef = useFormikForwardRef(ref);
  const initialValuesComputed = useMemo(() => initialValues, [initialValues])

  useEffect(() => {
    let infoArray = []
    if (initialValues.list !== undefined) {
      for (let i = 0; i < initialValues.list.length; i++) {
        const obj = {
          id: initialValues.list[i].photoId !== undefined ? initialValues.list[i].photoId : initialValues.list[i].id
        }
        infoArray.push(obj)
      }
      dispatch({
        type: actions.PEOPLE_MODULE_SELECT,
        data: infoArray,
      })
    }
    else {
      dispatch({
        type: actions.PEOPLE_MODULE_SELECT,
        data: infoArray,
      })
    }
  }, []);

  return (
    <Formik
      ref={formRef}
      validationSchema={ItemSchema(initialValues, context)}
      initialValues={initialValuesComputed}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
      validateOnMount
      enableReinitialize
    >
      <Form>
        <Field
          title="Título"
          name="title"
          info="Uma frase para secção"
          component={FieldCustom}
          maxLetters={120}
        />
        <Field
          name="list"
          isPeopleModule
          columns={[
            {
              accessor: 'name',
              Header: 'Nome',
            }
          ]}
          minItems={0}
          newItemText="Adicionar pessoas"
          component={FieldArrayDndFormik}
          rowKey={(item) => generateKey(item.id)}
          ItemForm={ItemFormItem}
        />
      </Form>
    </Formik>
  )
})

const SubWebPeopleEditor = ({ initialProps, onChange }) => {
  const [editorProps, setEditorProps] = useState(initialProps)
  const [call, setCall] = useState(initialProps.structure !== undefined ? initialProps.structure : false)
  const [droptabs, setdroptabs] = useState([]);
  const [Loading, setIsLoading] = useState(true)
  const [droptabCall, setDroptabCall] = useState(false)
  const { subweb, lang } = useParams();

  const [{
    user
  }] = useUserContext();
    
  const themeContext = useContext(ThemeContext)
  const subwebColor = useMemo(() => (
    user.subwebs.find(sub => (sub.slug === subweb))?.color ?? themeContext.colors.black
  ), [])

  const initialValues = useMemo(() => {
    const {
      data, 
      title, 
      droptab, 
      structure, 
      activeColor,
      ...values
    } = initialProps;
    let list = data?.map((item) => ({ ...item }))

    return {
      title,
      list,
      droptab,
      structure: structure !== undefined ? structure : false,
      ...values,
      hasLink: false,
      activeColor: subwebColor ?? activeColor
    };
  }, [initialProps]);

  const onFetchContentTabs = async (department, type) => {
    const res = await getPeopleTabs({
      department,
      type,
      lang
    });
    if (res.data.tabs.length > 0) {
      setdroptabs(computeDropTabs(res.data.tabs))
      const { droptab, ...values } = initialProps
      const newProps = {
        ...initialProps,
        ...values,
        droptab: droptab === undefined ? res.data.tabs[0].value : droptab
      }
      setEditorProps(newProps)
    }
  };

  if (!droptabCall) {
    setDroptabCall(true)
    onFetchContentTabs(subweb, '')
  }

  useEffect(() => {
    setCall(initialValues.structure)
  }, [initialValues.structure]);

  useEffect(() => {
    setIsLoading(false)
  }, [droptabs]);

  const handleFormChange = async (newValues, type) => {
    const {
      title, list, structure, droptab, isLoading, ...values
    } = newValues
    let data = null;
    data = list;

    if (structure === true) {
      setIsLoading(true)
      const props = {
        ...initialProps,
        ...values,
        isLoading: true
      }
      setEditorProps(props)

    }
    if (type === 'clean') {
      data = []
    }
    else if (type === 'load' && droptab !== undefined) {
      setIsLoading(true)
      const props = {
        ...initialProps,
        ...values,
        isLoading: true
      }
      setEditorProps(props)
      const requestType = getDepartmentPeople;
      
      data = await requestType({
        department: subweb,
        type: droptab !== undefined ? droptab : '',
        lang
      }); 

      if (data.data.data.length > 0) {
        const props = {
          ...initialProps,
          ...values,
          isLoading: false,
          droptab: data.data.tabs.length > 0 ? data.data.tabs[0].label : undefined
        }
        setEditorProps(props)
      }
      setdroptabs(computeDropTabs(data.data.tabs))
    }
    const newProps = {
      ...initialProps,
      ...values,
      hasLink: false,
      title,
      data: type === 'load' && droptab !== undefined ? data.data.data : data,
      structure,
      droptab: droptab !== undefined ? droptab : undefined
    }

    setEditorProps(newProps)
    setIsLoading(false) 
  };
  const onClickClean = () => {
    handleFormChange(initialValues, 'clean')
  };

  const onClickLoad = () => {
    handleFormChange(initialValues, 'load')
  };

  useDebounce(() => {
    onChange(editorProps);
  }, 200,
  [editorProps]
  )
  if (Loading) {
    return (
      <div>
      A carregar...
      </div>
    )
  }

  if (!call) {
    return (
      <Formik
        initialValues={initialValues}
        validate={handleFormChange}
        enableReinitialize
      >
        <Form>
          <Title as="h3">Conteúdos</Title>
          <Field
            title="Versão editável"
            name="structure"
            component={FieldToggle}
          />
          <Text modifiers={['xs']}> A versão editável permite organizar as pessoas da unidade em grupos personalizados ou construir outras soluções, à medida.
          A versão não editável mostra as pessoas da unidade organizadas por vínculo e categoria tal como registadas no sistema de recursos humanos. 
          </Text>  
        </Form>
      </Formik>
    );
  }
    
  return (
    <Formik
      initialValues={initialValues}
      validate={handleFormChange}
      enableReinitialize
    >
      <Form>
        <Title as="h3">Conteúdos</Title>
        <Field
          title="Versão editável"
          name="structure"
          component={FieldToggle}
        />
        <Text modifiers={['xs']}> A versão editável permite organizar as pessoas da unidade em grupos personalizados ou construir outras soluções, à medida.
          A versão não editável mostra as pessoas da unidade organizadas por vínculo e categoria tal como registadas no sistema de recursos humanos. 
        </Text>
        <Spacer bottom="m" />
        <Field
          title="Título"
          name="title"
          info="Indique o título do módulo"
          component={FieldCustom}
          maxLetters={120}
        />
        <Field
          name="list"
          newItemText="Novo grupo"
          component={FieldArrayDndFormik}
          minItems={0}
          disabled={call}
          columns={[
            {
              accessor: 'title',
              Header: 'Título',
            }
          ]}
          rowKey={(item) => generateKey(item.id)}
          ItemForm={ItemForm}
        />  
        <Spacer bottom="m" />
        <Text modifiers={['xs']}> Obter lista de pessoas atualizada por vínculo (esta lista irá substituir a lista atualmente apresentada no módulo) </Text>
        <Field
          name="droptab"
          placeholder="Selecione uma tab.."
          component={FieldSelect}
          options={droptabs}
        /> 
        <Button
          modifiers={['small', 'white', 'marginRight', 'stretch']}
          type="button"
          onClick={onClickLoad}
        >
                  Carregar dados      
        </Button>
        <Spacer bottom="m" />
        <Spacer bottom="m" />      
        <Button
          modifiers={['small', 'white', 'marginRight', 'stretch', 'danger']}
          type="button"
          onClick={onClickClean}
        >
                  Limpar dados      
        </Button>
      </Form>
    </Formik>
  );
};

SubWebPeopleEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialProps: PropTypes.shape({
    data: PropTypes.array,
    tabs: PropTypes.array,
    title: PropTypes.string,
    structure: PropTypes.bool,
    droptab: PropTypes.object,
    droptabs: PropTypes.array
  }),
};

SubWebPeopleEditor.defaultProps = {
  initialProps: {
    structure: false
  }
};

export default SubWebPeopleEditor;


